import { DraggableAttributes, useDraggable, useDroppable } from '@dnd-kit/core'
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { ReactNode } from 'react'

interface SortableProps {
  id: string
  className?: string
  children: (props: {
    attributes: DraggableAttributes
    listeners: SyntheticListenerMap | undefined
    isDragging: boolean
  }) => ReactNode
  effect?: boolean
}

export function Sortable({ id, children, className, effect = false }: SortableProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
  })
  return (
    <div
      ref={setNodeRef}
      style={effect ? { transform: CSS.Transform.toString(transform), transition } : undefined}
      className={className}
    >
      {children({ attributes, listeners, isDragging })}
    </div>
  )
}

export function Draggable({
  id,
  children,
  className,
}: {
  id: string
  children: (props: {
    attributes: DraggableAttributes
    listeners: SyntheticListenerMap | undefined
  }) => ReactNode
  className?: string
}) {
  const { attributes, listeners, setNodeRef } = useDraggable({ id })
  return (
    <div ref={setNodeRef} className={className}>
      {children({ attributes, listeners })}
    </div>
  )
}

export function Droppable({
  id,
  children,
  className,
}: {
  id: string
  children: (props: { isOver: boolean }) => ReactNode
  className?: string
}) {
  const { setNodeRef, isOver } = useDroppable({ id })
  return (
    <div ref={setNodeRef} className={className}>
      {children({ isOver })}
    </div>
  )
}
